import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	timecardUpdateRequestList: {
		requesting: false,
		items: [],
		pagination: {
			current_page: 1,
			per_page: 10,
			total: 0,
		},
		error: null,
		success: false,
		filters: {},
	},
	timecardUpdateRequestDetails: {
		requesting: false,
		error: null,
		success: false,
		data: null,
	},
};

export const timecardUpdateRequestSlice = createSlice({
	name: "timecardUpdateRequest",
	initialState,
	reducers: {
		getTimecardUpdateRequestList: (state) => {
			state.timecardUpdateRequestList.requesting = true;
			state.timecardUpdateRequestList.error = null;
			state.timecardUpdateRequestList.items = [];
			state.timecardUpdateRequestList.success = false;
		},
		getTimecardUpdateRequestListSuccess: (state, action) => {
			const { data, current_page, per_page, total, filters } = action.payload;

			state.timecardUpdateRequestList.requesting = false;
			state.timecardUpdateRequestList.items = data;
			state.timecardUpdateRequestList.success = true;
			state.timecardUpdateRequestList.pagination.current_page = current_page;
			state.timecardUpdateRequestList.pagination.per_page = per_page;
			state.timecardUpdateRequestList.pagination.total = total;
			state.timecardUpdateRequestList.filters = filters;
		},
		getTimecardUpdateRequestListFail: (state, action) => {
			state.timecardUpdateRequestList.requesting = false;
			state.timecardUpdateRequestList.error = action.payload;
		},

		getTimecardUpdateRequestDetails: (state) => {
			state.timecardUpdateRequestDetails.requesting = true;
			state.timecardUpdateRequestDetails.error = null;
			state.timecardUpdateRequestDetails.data = null;
			state.timecardUpdateRequestDetails.success = false;
		},
		getTimecardUpdateRequestDetailsSuccess: (state, action) => {
			state.timecardUpdateRequestDetails.requesting = false;
			state.timecardUpdateRequestDetails.data = action.payload;
			state.timecardUpdateRequestDetails.success = true;
		},
		getTimecardUpdateRequestDetailsFail: (state, action) => {
			state.timecardUpdateRequestDetails.requesting = false;
			state.timecardUpdateRequestDetails.error = action.payload;
		},

		doTimecardUpdateRequestCreate: (state) => {
			state.timecardUpdateRequestDetails.requesting = true;
			state.timecardUpdateRequestDetails.error = null;
			state.timecardUpdateRequestDetails.data = null;
			state.timecardUpdateRequestDetails.success = false;
		},
		doTimecardUpdateRequestCreateSuccess: (state, action) => {
			state.timecardUpdateRequestDetails.requesting = false;
			state.timecardUpdateRequestDetails.data = action.payload;
			state.timecardUpdateRequestDetails.success = true;
		},

		doTimecardUpdateRequestCreateFail: (state, action) => {
			state.timecardUpdateRequestDetails.requesting = false;
			state.timecardUpdateRequestDetails.error = action.payload;
			state.timecardUpdateRequestDetails.success = false;
		},
		doTimecardUpdateRequestUpdate: (state) => {
			state.timecardUpdateRequestDetails.requesting = true;
			state.timecardUpdateRequestDetails.error = null;
			state.timecardUpdateRequestDetails.data = null;
			state.timecardUpdateRequestDetails.success = false;
		},

		doTimecardUpdateRequestDelete: (state) => {
			state.timecardUpdateRequestDetails.requesting = true;
			state.timecardUpdateRequestDetails.error = null;
			state.timecardUpdateRequestDetails.data = null;
			state.timecardUpdateRequestDetails.success = false;
		},

		approveTimecardUpdateRequest: (state) => {
			state.timecardUpdateRequestDetails.requesting = true;
		},

		approveTimecardUpdateRequestSuccess: (state) => {
			state.timecardUpdateRequestDetails.requesting = false;
		},

		approveTimecardUpdateRequestFail: (state, action) => {
			state.timecardUpdateRequestDetails.requesting = false;
			state.timecardUpdateRequestDetails.error = action.payload;
		},

		resetTimecardUpdateRequestState: (state) => {
			state.timecardUpdateRequestDetails.success = false;
			state.timecardUpdateRequestDetails.error = null;
			state.timecardUpdateRequestDetails.data = null;
		},

		rejectTimecardUpdateRequest: (state) => {
			state.timecardUpdateRequestDetails.requesting = true;
		},

		rejectTimecardUpdateRequestSuccess: (state) => {
			state.timecardUpdateRequestDetails.requesting = false;
		},

		rejectTimecardUpdateRequestFail: (state, action) => {
			state.timecardUpdateRequestDetails.requesting = false;
			state.timecardUpdateRequestDetails.error = action.payload;
		},
		
	},
});

export const {
	getTimecardUpdateRequestList, getTimecardUpdateRequestListSuccess, 
	getTimecardUpdateRequestListFail, getTimecardUpdateRequestDetails, 
	getTimecardUpdateRequestDetailsSuccess, getTimecardUpdateRequestDetailsFail, 
	doTimecardUpdateRequestCreate, doTimecardUpdateRequestUpdate, 
	doTimecardUpdateRequestDelete, doTimecardUpdateRequestCreateSuccess, 
	doTimecardUpdateRequestCreateFail, resetTimecardUpdateRequestState,
	approveTimecardUpdateRequest, approveTimecardUpdateRequestSuccess,
	approveTimecardUpdateRequestFail, rejectTimecardUpdateRequest,
	rejectTimecardUpdateRequestSuccess, rejectTimecardUpdateRequestFail

} = timecardUpdateRequestSlice.actions;

export default timecardUpdateRequestSlice.reducer;